import api from 'api'
import { IBasicCourse } from 'interfaces/course'
import { CertificateType } from 'enum/certificateType.enum'

const saveTemplate = (
  title: string,
  content: string,
  backgroundImage: File | string | null,
  workspace: string,
  resource: number,
  templateToken?: string
) => {
  const formData = new FormData()

  formData.append('template[title]', title)
  formData.append('template[content]', content)
  if (typeof backgroundImage !== 'string') {
    formData.append('template[background_image]', backgroundImage || '')
  }
  formData.append('template[workspace]', workspace)
  formData.append('template[resource]', String(resource))

  if (templateToken) {
    formData.append('template[token]', templateToken)
    return api.patch('/administration/certificates/update_template', formData)
  } else {
    return api.post('/administration/certificates', formData)
  }
}

const getCourses = (search: string, page: number) => {
  return api.get(
    `administration/certificates/get_courses?q=${search}&page=${page}&per_page=10`
  )
}

const getConfiguration = (certificateId: number) => {
  return api.get(`administration/certificates/${certificateId}`)
}

const saveConfiguration = (
  certificateId: number,
  type: CertificateType,
  courses: IBasicCourse[]
) => {
  const formData = new FormData()

  formData.append('certificate[certificate_type]', String(type))
  courses.forEach((course, index) => {
    formData.append(
      `certificate[certificate_course_attributes][${index}][course_id]`,
      String(course.id)
    )
  })

  return api.put(`/administration/certificates/${certificateId}`, formData)
}

const getPreviewContent = (content: string) => {
  const formData = new FormData()
  formData.append('certificate[content]', content)

  return api.post('administration/certificates/preview', formData)
}

const duplicate = (token: string) => {
  return api.post(`/administration/certificates/duplicate/${token}`)
}

export const certificatesService = {
  saveTemplate,
  getCourses,
  getConfiguration,
  saveConfiguration,
  getPreviewContent,
  duplicate,
}
